import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function Seat() {
  const location = useLocation();
  const [seatUse, setSeatUse] = useState({"in_use": 0, "available": 0, "total"  : 0});
  const [loaded, setLoaded] = useState(false);
  const [err, setErr] = useState(null);
  const [message, setMessage] = useState("");

  const getSeats = async () => {
    try {
      const accountID = localStorage.getItem('facesAccountID');
      if(!accountID) {
        setErr(" ")
        return;
      }
      const res = await fetch(
        process.env.REACT_APP_FACES_API_BASE +
          `/seats-in-use?account_id=${accountID}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!res.ok) {
        setErr('Failed to retrieve seats.');
        console.error('Error getting seats: ' + res.statusText);
        return;
      }
      const json = await res.json();

      setSeatUse({
        in_use: json.seats_in_use,
        available: json.seats_available,
        total: json.total_seats,
      });
      setErr(null);
    } catch (e) {
      setErr('Failed to retrieve seats.');
      console.error('Error getting seats: ' + e);
    } finally {
      setLoaded(true);
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("logout") === "true") {
      console.log("Logout flag detected");
      setMessage("You have successfully logged out. It may take up to 2 minutes for your seat to become available again.");
    }
  }, [location]);

  useEffect(() => {
    let id = null;
    getSeats().then((res) => {
      id = setInterval(getSeats, 10000);
    })
    return () => clearInterval(id);
  }, []);

  if(!loaded) {
    return(<span>Retrieving seat usage...</span>)
  }

  if(err) {
    return(<span>{err}</span>)
  }

  return(<span className="seatContainer">
    <p>{message}</p>
    <p>{seatUse.in_use} of {seatUse.total} seats in use.</p>
  </span>)
}